export default {
  SET_DELAY (state, value) {
    state.delay = value
  }
}
